<template>
    <div>
        <div v-if="deal.banner.version === 'v1'" class="ls-deal-banner__container">
            <span v-if="!desktop"
                >Book in <strong>{{ timeLeft }}</strong> and your first mow is only
                <strong>$19</strong>!</span
            >
            <span v-else
                >Deal Applied: Schedule in the next <strong>{{ timeLeft }}</strong> and get your
                first service for only <strong>$19</strong>!</span
            >
        </div>
        <div v-if="deal.banner.version === 'v2'" class="ls-deal-banner__container">
            <span v-if="deal.validDeal.price_firstjob"
                >Coupon applied! Check out in the next <strong>{{ timeLeft }}</strong> and get your
                first mow for only
                <strong>{{ (deal.validDeal.price_firstjob / 100) | lsMoney }}</strong></span
            >
            <span v-else
                >Coupon applied! Check out in the next <strong>{{ timeLeft }}</strong> and get
                <strong>{{ (deal.validDeal.credit / 100) | lsMoney }}</strong> off your first
                service</span
            >
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { SCREEN_SIZE__GET_DESKTOP_SCREEN, DEAL__UPDATE_BANNER } from '@/store/types';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
    data() {
        return {
            futureTimestamp: moment().add(this.$store.state.deal.banner.minutes, 'minutes'),
            currentTimestamp: moment(),
        };
    },
    mounted() {
        this.interval = setInterval(() => {
            this.currentTimestamp = moment();
        }, 1000);
    },
    destroyed() {
        clearInterval(this.interval);
    },
    computed: {
        timeLeft() {
            const timeLeft = this.futureTimestamp - this.currentTimestamp;
            if (timeLeft <= 0) {
                this.updateBanner({});
                clearInterval(this.interval);
            }
            return moment(timeLeft).format('mm:ss');
        },
        ...mapState(['deal']),
        ...mapGetters({
            desktop: SCREEN_SIZE__GET_DESKTOP_SCREEN,
        }),
    },
    methods: {
        ...mapActions({
            updateBanner: DEAL__UPDATE_BANNER,
        }),
    },
};
</script>

<style lang="scss" scoped>
.ls-deal-banner__container {
    @include max-screen(344px) {
        // for small phones (iPhone 5)
        font-size: rem(-1);
    }
    color: palette(white);
    background: palette(blue);
    padding: 5px;
    text-align: center;
}
.themed-app {
    .ls-deal-banner__container {
        color: $theme-color-white;
        background: $theme-color-blue;
    }
}
</style>
